import React from "react";
import { Box, BoxProps } from "@mui/material";

const BankIDBtnLogo: React.FC<BoxProps> = (props) => {
  return (
    <Box component="img" src="/images/BankIDLogo.svg" alt="BankID logo"/>
  )
};

export default BankIDBtnLogo;
